import { useContext } from 'react';

import { CredentialTypeStateContext } from './CredentialTypeContextProvider';

import CredentialTypeData from './CredentialTypeData';

const useCredentialTypeData = () => {
  const [credentialTypeState, setCredentialTypeState] = useContext(CredentialTypeStateContext);

  const getCredentialTypes = () => {
    CredentialTypeData.getCredentialTypeData(credentialTypeState, setCredentialTypeState);
  };

  return {
    credentialTypeState,
    setCredentialTypeState,
    getCredentialTypes
  };
};

export default useCredentialTypeData;